import { Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { TailoredValue, TailoredValueChip } from "routes/asset-register/plugins/general-tailoring/tailored-value"
import { AmendsChangeType } from "authoring/lib/enum/amends-change-type.mjs"
import { AuthoringAddedTaskTailoredValue } from "./authoring-added-task-tailored-value"

export function AuthoringTailoredValue({ item: key, original, tailored, chipSx }) {
    if (key === "changeType") {
        const isLegislation =
            tailored?.legislationId != null ||
            original?.legislationId != null ||
            Array.isArray(tailored?.legislation) ||
            Array.isArray(original?.legislation)
        return renderChangeTypeChip(tailored?.changeType, chipSx, isLegislation)
    }
    if (key === "code") {
        return renderCodeChangeChip({ original, tailored, chipSx })
    }
    if (key === "introContent") {
        return renderLabelChip("Schedule Introduction Edited", chipSx)
    }
    if (key === "introNote") {
        return renderLabelChip("Introduction Notes Edited", chipSx)
    }
    if (tailored?.changeType === AmendsChangeType.ADDED) {
        return <AuthoringAddedTaskTailoredValue item={key} tailored={tailored} chipSx={chipSx} />
    }
    if (key === "unitOfMeasure") {
        return renderUnitOfMeasureChip({ original, tailored, chipSx })
    }
    return <TailoredValue item={key} original={original} tailored={tailored} chipSx={chipSx} />
}

function renderChangeTypeChip(changeType, chipSx, isLegislation) {
    let value = null
    let color = "info"

    if (changeType === AmendsChangeType.ADDED) {
        const label = isLegislation ? "Reference Added" : "Task Created"
        value = (
            <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                {label}
            </Typography>
        )
        color = "success"
    }
    if (changeType === AmendsChangeType.REMOVED) {
        const label = isLegislation ? "Reference Removed" : "Task Deleted"
        value = (
            <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                {label}
            </Typography>
        )
        color = "error"
    }

    if (!value) return null
    return renderChip({ value, color, chipSx })
}

function renderCodeChangeChip({ original = {}, tailored = {}, chipSx }) {
    if (tailored?.code == null && original?.code == null) return null

    const value = (
        <Stack direction="row" spacing={1} alignItems="center">
            <TruncatedTypography variant="body2" color="tailoredValueColors.text.main" sx={{ fontWeight: "bold" }}>
                {tailored.code}
            </TruncatedTypography>
            <Iconify icon="mdi:arrow-left" size={20} />
            <TruncatedTypography variant="body2" color="tailoredValueColors.text.lighter">
                {original.code}
            </TruncatedTypography>
        </Stack>
    )

    return renderChip({ value, color: "info", chipSx })
}

function renderLabelChip(label, chipSx) {
    return renderChip({
        value: (
            <TruncatedTypography
                variant="body2"
                color="tailoredValueColors.text.main"
                sx={{ fontWeight: "bold", wordWrap: "break-word" }}
            >
                {label}
            </TruncatedTypography>
        ),
        color: "info",
        chipSx,
    })
}

function renderUnitOfMeasureChip({ original = {}, tailored = {}, chipSx }) {
    if (tailored?.unitOfMeasure == null && original?.unitOfMeasure == null) return null

    const value = (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="caption">UoM</Typography>
            <TruncatedTypography variant="body2" color="tailoredValueColors.text.main" sx={{ fontWeight: "bold" }}>
                {tailored.unitOfMeasure}
            </TruncatedTypography>
            <Iconify icon="mdi:arrow-left" size={20} />
            <TruncatedTypography variant="body2" color="tailoredValueColors.text.lighter">
                {original.unitOfMeasure}
            </TruncatedTypography>
        </Stack>
    )

    return renderChip({ value, color: "info", chipSx })
}

function renderChip({ value, color, chipSx }) {
    return <TailoredValueChip color={color} chipSx={chipSx} label={value} />
}
